var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-buddy-button-rounded font-outfit-regular",class:{'ai-buddy-animation-pulse-button': _vm.animation || _vm.localAnimation}},[_c('i',{staticClass:"ib-icon ib-icon-magic-2 cursor-pointer",on:{"click":_vm.onClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }